function getCookieValue(cookieName) {
  if (cookieName === null) {
    return null;
  }

  const cookies = document.cookie ? document.cookie.split('; ') : [];
  const cookie = cookies.find((cookieString) => {
    const name = cookieString.split('=')[0];
    return name === cookieName;
  });
  if (!cookie) {
    return null;
  }

  const value = cookie.split('=')[1];
  return value;
}

function setCookie(name, value, attributes = {}) {
  // Set defaults
  attributes = {
      path: '/',
      ...attributes
  };

  let cookie = name + "=" + value;

  // Add attributes
  for (let key in attributes) {
      cookie += "; " + key;
      let value = attributes[key];
      if (value !== true) {
          cookie += "=" + value;
      }
  }

  document.cookie = cookie;
}

function customEncodeValue(value) {
  let encodedValue = `${value}`;
  encodedValue = encodedValue.replaceAll(" ", "_SPACE_");
  encodedValue = encodedValue.replaceAll(",", "_COMMA_");
  encodedValue = encodedValue.replaceAll(";", "_SEMICOLON_");

  return encodedValue;
}

export { getCookieValue, setCookie, customEncodeValue };
